import React, { CSSProperties, ReactNode } from 'react'

export interface FloatingCardProps {
  children: ReactNode
  style?: CSSProperties
  className?: string
}

export const FloatingCard: React.FC<FloatingCardProps> = ({
  children,
  style,
  className,
}) => {
  const classes = ['floating-card', className].filter(Boolean).join(' ')

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  )
}
